/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
import Vue from 'vue'
import VueRouter from 'vue-router'
import getUserAnalitycsTool from './tools/userAnalytics'
import indexedDBState from './tools/userAnalytics/IndexedDBState'
import analyticsEventsHandlers from './tools/userAnalytics/analyticsEventsHandlers'
import store from './store'

Vue.use(VueRouter)

const router = new VueRouter({
  linkExactActiveClass: 'active',
  mode: 'history',
  base: process.env.VUE_APP_BASE_PATH,
  routes: [
    {
      path: '*'
    }
  ]
})

// Отслеживание смены страниц пользователем и запись в аналитику
router.afterEach((to, from) => {
  // Если аналитика выключена пользователем
  if (!store.state?.appRunner?.model?.Settings?.isUseAnalytics) {
    return 
  }

  const userGetter = store.getters?.userLogin
  const userAnalyticsTools = getUserAnalitycsTool(indexedDBState, userGetter, store.state.general.analitycsSessionId)
  // Инициализация браузерных ивентов (один раз)
  analyticsEventsHandlers.initializeEvents(userAnalyticsTools, router)

  /**
  * Отслеживаем первую загрузку страницы. from.name имеет значение null при загрузке первой страницы.
  * Если страница первая, нужно сохранить начало сессии для аналитики
  */
   if (from.name === null) {
    userAnalyticsTools.onSessionStartAction(to.name)
  } else {
    // При смене страницы, сохранить это действие в аналитику
    userAnalyticsTools.onPageOpenAction(to.name)
  }
})

// регистронезависимые роуты
router.history.getCurrentLocation = () => {
  let path = window.location.pathname
  let base = router.history.base
  // Removes base from path (case-insensitive)
  if (base && path.toLowerCase().indexOf(base.toLowerCase()) === 0) {
    path = path.slice(base.length)
  }
  return (path || '/') + window.location.search + window.location.hash
}
export default router
